import { collection, getDocs } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { Studio } from "../types";

export const getStudiosList = async (): Promise<Studio[]> => {
  const collectionRef = collection(db, "studios");

  const studiosSnapshot = await getDocs(collectionRef);

  return studiosSnapshot.docs.map((doc) => doc.data() as Studio);
};
